module.exports = __webpack_public_path__ + "img/aj-2000-web.7dd012c4.jpg";